import { CompanyDetailAndJobGroups } from '@types';
import { DetailColumn, DetailSection } from 'redesign';
import { useTranslation } from 'react-i18next';
import { EmployeeContractRequestedInfoTooltip } from './components/employee-contract-requested-info-tooltip';
import { SettingsDetailToolbox } from './settings-detail-toolbox';

export const SettingsDetail = ({ companyData }: { companyData: CompanyDetailAndJobGroups }) => {
  const { t } = useTranslation(['web-common', 'ogp-screen-specific']);

  const translateYesAndNo = (value: boolean) =>
    value
      ? t('confirmation-yes', { ns: 'web-common' })
      : t('confirmation-no', { ns: 'web-common' });

  const columns: DetailColumn[] = [
    {
      items: [
        {
          title: t('employment-type.freelancer', { ns: 'web-common' }),
          value: translateYesAndNo(companyData.company.offersFreelanceWork),
        },
        {
          title: t('employment-type.tempworker', { ns: 'web-common' }),
          value: translateYesAndNo(companyData.company.offersTempWork),
        },
        {
          title: t('employment-type.employee', { ns: 'web-common' }),
          value: translateYesAndNo(companyData.company.offersEmployeeWork),
        },
      ],
    },
    ...(companyData.company.offersEmployeeWork
      ? [
          {
            items: [
              {
                title: t('settings-detail-page.employee-mutable-until-minutes-header', {
                  ns: 'ogp-screen-specific',
                }),
                value: (companyData.company.employeeMutableUntilMinutes / 60).toString(),
              },
              {
                title: t('settings-detail-page.employee-contract-requested-header', {
                  ns: 'ogp-screen-specific',
                }),
                value: translateYesAndNo(companyData.company.requiresEmployeeContract),
                tooltip: <EmployeeContractRequestedInfoTooltip />,
              },
              {
                title: t('settings-detail-page.employee-certificates-requested-header', {
                  ns: 'ogp-screen-specific',
                }),
                value: translateYesAndNo(companyData.company.requiresEmployeeCertificates),
              },
              {
                title: t('settings-detail-page.allow-shift-start-time-override-header', {
                  ns: 'ogp-screen-specific',
                }),
                value: translateYesAndNo(companyData.company.allowShiftStartTimeOverride),
              },
              {
                title: t('settings-detail-page.allow-shift-end-time-override-header', {
                  ns: 'ogp-screen-specific',
                }),
                value: translateYesAndNo(companyData.company.allowShiftEndTimeOverride),
              },
            ],
          },
        ]
      : []),
  ];

  return (
    <>
      <SettingsDetailToolbox companyData={companyData} />
      <DetailSection columns={columns} />
    </>
  );
};
